<app-loading [loading]="loading()" [theme]="'transparent'" />

@if (!loading()) {
    @for (session of sessions(); track session.id; let i = $index) {
            <div class="info-box" [attr.data-testid]="'WaltDetailHistory-Session-' + i" [class.info-box--active]="isSessionActive(session, i)">
                <!-- Row 1: avatar & person name -->
                <div class="session-row">
                    <app-avatar-person
                        [personId]="session.personId"
                        [size]="25"
                        [showCompanyRing]="true"
                        [showAvailability]="false"
                    />
                    <p class="session-person">{{ session.personName }}</p>
                </div>

                <!-- Row 2: Logged-in label & date -->
                <div class="session-row">
                    <p class="session-label">{{ 'devices.history.logged-in' | translate }}</p>
                    <p class="session-date" [title]="session.loginDate | date: 'medium'">{{ session.loginDate | date: 'MMM d, h:mm a' }}</p>
                </div>

                <!-- Row 3: end event label & date (or currently active banner) -->
                @if (session.endType === EventType.WaltDocked) {
                    <div class="session-row">
                        <p class="session-label">{{ 'walt.status.docked' | translate }}</p>
                        <p class="session-date" [title]="session.endDate | date: 'medium'">{{ session.endDate | date: 'MMM d, h:mm a' }}</p>
                    </div>
                } @else if (session.endType === EventType.WaltPoweredOff) {
                    <div class="session-row" [attr.data-testid]="'WaltDetailHistory-Session-' + i + '-PoweredOff'">
                        <p class="session-label">{{ 'devices.history.powered-off' | translate }}</p>
                        <p class="session-date" [title]="session.endDate | date: 'medium'">{{ session.endDate | date: 'MMM d, h:mm a' }}</p>
                    </div>
                    <div class="session-row" [attr.data-testid]="'WaltDetailHistory-Session-' + i + '-Reason'">
                        <p class="session-label">{{ 'walt.reason' | translate }}</p>
                        <p class="session-date">{{ poweredOffReasonKey(session.endReason) | translate }}</p>
                    </div>
                } @else if (session.endType === EventType.WaltLogout) {
                    <div class="session-row">
                        <p class="session-label">{{ 'devices.history.logged-out' | translate }}</p>
                        <p class="session-date" [title]="session.endDate | date: 'medium'">{{ session.endDate | date: 'MMM d, h:mm a' }}</p>
                    </div>
                } @else if (!isSessionActive(session, i)) {
                    <div class="session-row" [attr.data-testid]="'WaltDetailHistory-Session-' + i + '-Ended'">
                        <p class="session-label">{{ 'devices.history.ended' | translate }}</p>
                    </div>
                } @else {
                    <div class="session-active-banner" [attr.data-testid]="'WaltDetailHistory-Session-' + i + '-CurrentlyActive'">
                        {{ 'devices.history.currently-active' | translate }}
                    </div>
                }
            </div>
        }

        @if (hasMore()) {
            <app-loading [loading]="loadingMore()" [theme]="'transparent'" />
            <div #sentinel class="sentinel"></div>
        } @else {
            <div class="no-history">
                <p>{{ 'devices.history.no-previous-history' | translate }}</p>
            </div>
        }
}
